import type { Member } from "@opulancia/deposit-core";
import type { Connection } from "./connection.js";

export interface App {
  connection: Connection;
  member: Member;
  members: Map<string, string>;
  navigate(hash: string): void;
  /** Re-renders the current screen (after a background change). */
  refresh(): void;
  /** Blocks closing the tab while something would be lost. */
  setBusy(busy: boolean): void;
  /** Runs once when the current screen is left (an editor saving its last changes). */
  onLeave(fn: () => void): void;
}

export const memberName = (app: App, id: string | null) => (id ? (app.members.get(id) ?? "membre") : "service");
